import EntityFinderTabBase from "./EntityFinderTabBase.jsx";
import {STORE_KEYS} from "../../../other/constants/StoreKeys.jsx";
import TaskDrag from "../../widget/extendingClasses/TaskDrag.jsx";
import { getScheduleInstanceFromViewManager } from "../../../other/utils/otherUtils.jsx";
import { ENTITY_TYPES } from "@/other/constants/OtherKeys.jsx";

export default class EntityFinderTaskTab extends EntityFinderTabBase {

  static get $name() {
    return "EntityFinderTaskTab";
  }

  static get type() {
    return "entityfindertasktab";
  }

  static get configurable() {
    return super.getTabWidget("Tasks", { field: "name", type: "unplannedTask", cellCls: "b-sch-horizontal" });
  }

  onOpenEntityEditor({ record }) {
    this.entityManager.openEntityManager({ entityType: ENTITY_TYPES.TASK, entityId: record.id });
  }

  get storeKey() {
    return STORE_KEYS.taskStore;
  }

  editRecord(record, context, otherParams) {
    // prevent TaskDrag to be attached multiple times on grid as this will cause
    // the record to be dragged on timeaxis view multiple times
    if (otherParams.isFirstShow) {
      const { entityGrid } = this.widgetMap;
      if (context.viewManager.pageViewsRef) {
        const schedularInstance = getScheduleInstanceFromViewManager(context.viewManager);
        if (schedularInstance) {
          new TaskDrag({
            grid: entityGrid,
            schedule: schedularInstance,
            constrain: false,
            outerElement: entityGrid.element
          })
        }
      }
    }

    super.editRecord(record, context, otherParams);
  }
}
EntityFinderTaskTab.initClass();
